import { useState } from "react";
import { useTranslation } from "react-i18next";

import { DetailsCard } from "components";
import { CommunicationLogs } from "modules/AppointmentDetails/components/KioskCommunicationLog/components";
import "modules/AppointmentDetails/components/KioskCommunicationLog/KioskCommunicationLog.scss";

import type { Appointment } from "models";

type KioskCommunicationLogProps = {
  appointment: Appointment;
};

export const KioskCommunicationLog = ({ appointment }: KioskCommunicationLogProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  const handleToggleIsModalOpen = (evt: React.MouseEvent) => {
    evt.stopPropagation();

    setIsModalOpen(!isModalOpen);
  };

  const { kiosk_communications } = appointment;

  if (!kiosk_communications?.length) return null;

  return (
    <>
      <div className="KioskCommunicationLog" onClick={handleToggleIsModalOpen}>
        <DetailsCard title={t("v8_kiosk_comm_log", "Kiosk Communication Log")} icon="user" rightContent={null} showExpandArrow={false} button />
      </div>
      <CommunicationLogs appointment={appointment} isModalOpen={isModalOpen} onToggleIsModalOpen={handleToggleIsModalOpen} />
    </>
  );
};
